export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Confirmation requise"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["L'autorisation doit être confirmée par une clé à usage unique"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["L'autorisation doit être confirmée par le mot magique"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["L'inscription doit être confirmée par un code SMS"])}
}